import {
  BaseballTracerIcon,
  BaseballTracking,
  DownloadThreeD,
  DownloadTwoD,
  DownloadVideo,
} from "./iconComponents";

export const tracerBtnsData = [
  {
    key: "tracking",
    icon: BaseballTracerIcon,
    title: "Tracking",
    active: true,
  },
  {
    key: "handTracer",
    icon: BaseballTracking,
    title: "Hand Tracer",
    active: true,
  },
];
